import React, { useContext, useState, useEffect } from 'react';
import { LanguageContext } from '../components/LanguageContext';
import { Card } from 'antd';
import axios from 'axios';

const Events = () => {
  const { language } = useContext(LanguageContext);
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedEvent, setSelectedEvent] = useState(null);

  function getCSRFToken() {
    return window.CSRF_TOKEN || '';
  }

  useEffect(() => {
    fetchNewsEvents();
  }, []);

  const fetchNewsEvents = async () => {
    try {
      const response = await axios.get('/api/get/news-events', {
        headers: {
          "X-CSRFToken": getCSRFToken(),
        },
        skipInterceptor: true,
      });
      setEvents(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching news events:', error);
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="relative">
        <div className="h-[300px] relative">
          <img 
            src="https://th-i.thgim.com/public/migration_catalog/article10456065.ece/alternates/FREE_1200/amaravathi"
            alt={language === 'en' ? "Academy Events Header" : "اکیڈمی کے ایونٹس ہیڈر"} 
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-blue-900/40">
            <div className="container mx-auto px-8 h-full flex items-center">
              <div className="max-w-2xl text-white">
                <h1 className="text-3xl md:text-5xl font-bold mb-4">
                  {language === 'en' ? "Upcoming Events" : "آنے والے ایونٹس"}
                </h1>
                <p className="text-lg md:text-xl">
                  {language === 'en'
                    ? "Join us in celebrating Urdu language and culture"
                    : "اردو زبان اور ثقافت کا جشن منانے میں ہمارا ساتھ دیں"}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <div className="container mx-auto px-8 py-6 md:py-12">
        {loading ? (
          <div className="flex items-center justify-center h-64">
            <div className="text-xl text-blue-800">
              {language === 'en' ? 'Loading...' : 'لوڈ ہو رہا ہے...'}
            </div>
          </div>
        ) : selectedEvent ? (
          <div>
            <button
              onClick={() => setSelectedEvent(null)}
              className="mb-6 text-blue-600 hover:text-blue-800 flex items-center gap-2"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
              {language === 'en' ? 'Back to Events' : 'واقعات پر واپس جائیں'}
            </button>

            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <img
                src={selectedEvent.cover_photo}
                alt={selectedEvent.title}
                className="w-full h-96 object-cover"
              />
              <div className="p-8">
                <h1 className="text-3xl md:text-4xl font-bold text-blue-800 mb-4">
                  {selectedEvent.title}
                </h1>
                <p className="text-sm text-gray-500 mb-6">
                  {new Date(selectedEvent.created_at).toLocaleDateString(language === 'en' ? 'en-US' : 'ur-PK', {
                    weekday: 'long',
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  })}
                </p>

                {selectedEvent.description_1 && (
                  <div className="mb-8">
                    <p className="text-gray-700 text-lg leading-relaxed whitespace-pre-wrap">
                      {selectedEvent.description_1}
                    </p>
                  </div>
                )}

                {(selectedEvent.photo_1 || selectedEvent.photo_2 || selectedEvent.photo_3 || selectedEvent.photo_4) && (
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
                    {[1, 2, 3, 4].map((num) => 
                      selectedEvent[`photo_${num}`] && (
                        <img
                          key={num}
                          src={selectedEvent[`photo_${num}`]}
                          alt={`Photo ${num}`}
                          className="w-full h-64 object-cover rounded-lg"
                        />
                      )
                    )}
                  </div>
                )}

                {selectedEvent.description_2 && (
                  <div className="mb-8">
                    <p className="text-gray-700 text-lg leading-relaxed whitespace-pre-wrap">
                      {selectedEvent.description_2}
                    </p>
                  </div>
                )}

                {(selectedEvent.photo_5 || selectedEvent.photo_6 || selectedEvent.photo_7 || selectedEvent.photo_8) && (
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {[5, 6, 7, 8].map((num) => 
                      selectedEvent[`photo_${num}`] && (
                        <img
                          key={num}
                          src={selectedEvent[`photo_${num}`]}
                          alt={`Photo ${num}`}
                          className="w-full h-64 object-cover rounded-lg"
                        />
                      )
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        ) : events.length === 0 ? (
          <Card className="text-center p-8 shadow-md">
            <h2 className="text-2xl font-bold text-blue-800 mb-2">
              {language === 'en' ? "Exciting Events Coming Soon!" : "دلچسپ ایونٹس جلد آ رہے ہیں!"}
            </h2>
            <p className="text-gray-600">
              {language === 'en' 
                ? "Stay tuned for our upcoming cultural events and activities." 
                : "ہماری آنے والی ثقافتی تقریبات اور سرگرمیوں کے لیے منتظر رہیں۔"}
            </p>
          </Card>
        ) : (
          <div className="space-y-6">
            {events.map((event) => (
            <div key={event.id} className="p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow overflow-hidden">
              <div className="md:flex">
                <div className="md:w-1/3">
                  <img 
                    src={event.cover_photo} 
                    alt={event.title}
                    className="h-48 w-full md:h-full object-cover rounded-lg"
                  />
                </div>
                <div className="md:w-2/3 md:pl-6 mt-4 md:mt-0">
                  <div className="flex items-center gap-2 text-blue-800 text-sm mb-2">
                    <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24"><path d="M5 3h14v2H5V3zM4 8h16v12H4V8zm10 3h4v4h-4v-4zm-8 0h4v4H6v-4zm0 5h4v2H6v-2zm8 0h4v2h-4v-2z"/></svg>
                    {new Date(event.created_at).toLocaleDateString(language === 'en' ? 'en-US' : 'ur-PK', {
                      weekday: 'long',
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric'
                    })}
                  </div>
                  <h2 className="text-xl md:text-2xl font-bold text-blue-800 mb-2">{event.title}</h2>
                  {event.description_1 && (
                    <p className="text-gray-600 mb-4 line-clamp-3">{event.description_1}</p>
                  )}
                  <button 
                    onClick={() => setSelectedEvent(event)}
                    className="mt-4 bg-blue-800 text-white px-6 py-2 rounded-lg hover:bg-blue-900 transition-colors flex items-center gap-2"
                  >
                    {language === 'en' ? "View Details" : "تفصیلات دیکھیں"}
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Events;
 
